export const encodeJSON = (input: unknown): string =>
  JSON.stringify(input, (_, value) =>
    typeof value === "bigint" ? { B_I_G_I_N_T: value.toString() } : value,
  )

export const convertToSnakeCase = (
  value: string,
  divider: RegExp | string = " ",
) => value.toLowerCase().split(divider).join("_")

export const safeFetch = async <T>(
  url: URL,
  errorMessage: string,
  options?: RequestInit,
): Promise<T> => {
  try {
    const response = await fetch(url, { credentials: "include", ...options })

    if (!response.ok) {
      throw new Error(`${errorMessage}: ${response.status}`)
    }

    return await response.json()
  } catch (error) {
    const messageFromError =
      error instanceof Error ? error.message : "An unknown error occurred"

    throw new Error(messageFromError)
  }
}
